<template>
  <v-tabs fixed centered v-if="classInfo">
    <!-- <v-parallax 
      height="200" 
      src="http://papers.co/wallpaper/papers.co-vk50-android-lollipop-material-design-dark-bw-pattern-31-wallpaper.jpg"
    > -->
      <v-container fill-height fluid>
        <v-layout fill-height justify-center align-center column>
          <div class="headline">{{ classInfo.subject + ' -'}} {{ classInfo.classroom_name }}</div>
          <div class="subheading text-xs-center">{{ classInfo.section }}</div>
          <div class="mt-2">
            <v-avatar size="42px">
              <img :src="classInfo.instructor.image" :alt="classInfo.instructor.family_name" class="mr-3">
            </v-avatar>
            <span class="px-0">{{classInfo.instructor.given_name}} {{ classInfo.instructor.family_name }}</span>
          </div>
        </v-layout>
      </v-container>
    <!-- </v-parallax> -->
    <v-tabs-bar class="green darken-2" dark>
      <v-tabs-slider class="yellow"></v-tabs-slider>
      <v-tabs-item
        v-for="i in items"
        :key="i"
        :href="'#' + i"
      >
        {{ i }}
      </v-tabs-item>
    </v-tabs-bar>
    <v-tabs-items>
      <v-tabs-content id="Feed">
        <add-post></add-post>
        <post 
          v-for="postData in posts"
          :key="postData.post_id"
          :post="postData"
        ></post>
      </v-tabs-content>
      <v-tabs-content id="Students">
        <v-container fluid>
          <v-layout>
            <v-flex xs12 md6 offset-md3>
              <student-list
                v-for="student in students"
                :key="student.student_id"
                :student="student"
                :fetchStudents="fetchStudents"
              ></student-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tabs-content>
      <v-tabs-content id="Files">
        <file-list
          :files="files"
        ></file-list>
      </v-tabs-content>
      <v-tabs-content id="Assignments">
        <assignment-list
          :assignments="assignments"
        ></assignment-list>
      </v-tabs-content>
    </v-tabs-items>
    <!-- <div style="height: 1000px"></div> -->
  </v-tabs>
</template>

<script>
import axios from 'axios'
import Post from './Classroom/Post.vue'
import AddPost from './Classroom/AddPost.vue'
import StudentList from './Classroom/Students.vue'
import FileList from './Classroom/Files.vue'
import AssignmentList from './Classroom/Assignments.vue'
export default {
  components: {
    Post, AddPost, StudentList, FileList, AssignmentList
  },
  data () {
    return {
      items: ['Feed', 'Students', 'Files', 'Assignments'],
      classInfo: '',
      students: []
    }
  },
  async created(){
    this.$store.dispatch('admin/FETCH_POSTS', {class_id: this.$route.params.id})
    this.$store.dispatch('admin/FETCH_FILES', {class_id: this.$route.params.id})
    this.$store.dispatch('admin/FETCH_ASSIGNMENTS', {class_id: this.$route.params.id})

    this.fetchStudents()
  },
  methods: {
    async fetchStudents(){
      try{
      let info = await axios.get(`/api/class/${this.$route.params.id}`, 
        { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } })
        this.classInfo = info.data
        this.students = info.data.studentclass
      }catch(e){
        console.log(e)
      }
    }
  },
  computed: {
    posts(){
      return this.$store.getters['admin/GET_POSTS']
    },
    files(){
      return this.$store.getters['admin/GET_FILES']
    },
    assignments(){
      return this.$store.getters['admin/GET_ASSIGNMENTS']
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Admin/Classroom.vue